import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Apple, Plus, Trash2 } from "lucide-react";

// Nutrition plans assigned to clients.
const NutritionTab = ({
  clients,
  deleteMealPlan,
  mealPlans,
  setMealPlanOpen,
  setNewMealPlan,
}) => {
  return (
    <div className="nutrition-view">
      <div className="view-header">
        <h1>Plany żywieniowe</h1>
        <Button onClick={() => { setNewMealPlan({ name: "", client_id: "", target_calories: "", target_protein: "", target_carbs: "", target_fat: "", meals: [] }); setMealPlanOpen(true); }}>
          <Plus size={18} /> Nowy plan
        </Button>
      </div>

      {mealPlans.length === 0 ? (
        <Card className="empty-state">
          <CardContent>
            <Apple size={48} strokeWidth={1} />
            <h3>Brak planów żywieniowych</h3>
            <p>Stwórz plan z celami makro dla klientów</p>
          </CardContent>
        </Card>
      ) : (
        <div className="nutrition-grid">
          {mealPlans.map(plan => {
            const clientName = clients.find(c => c.id === plan.client_id)?.name || "?";
            return (
              <Card key={plan.id} className="nutrition-card">
                <div className="template-card-actions">
                  <Button variant="ghost" size="sm" onClick={() => deleteMealPlan(plan.id)}>
                    <Trash2 size={14} />
                  </Button>
                </div>
                <CardContent>
                  <Apple size={24} />
                  <div className="template-details">
                    <h3>{plan.name}</h3>
                    <span className="nutrition-client">{clientName}</span>
                    <div className="nutrition-macros">
                      {plan.target_calories && <Badge variant="outline">{plan.target_calories} kcal</Badge>}
                      {plan.target_protein && <Badge variant="secondary">B: {plan.target_protein}g</Badge>}
                      {plan.target_carbs && <Badge variant="secondary">W: {plan.target_carbs}g</Badge>}
                      {plan.target_fat && <Badge variant="secondary">T: {plan.target_fat}g</Badge>}
                    </div>
                    <div className="nutrition-meals-count">{plan.meals?.length || 0} posiłków</div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default NutritionTab;
